import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticleMainGuide from "@/pages/article/jak-korzystac-z-kakobuy-spreadsheet/page";
import ArticleTop50 from "@/pages/article/kakobuy-spreadsheet-top-50-produktow/page";
import ArticleQC from "@/pages/article/kakobuy-qc-kompletny-poradnik/page";
import ArticleShipping from "@/pages/article/wysylka-do-polski-z-chin-kakobuy/page";
import ArticleVs from "@/pages/article/kakobuy-vs-pandabuy-porownanie-2026/page";
import ArticleNike from "@/pages/article/kakobuy-spreadsheet-nike-najlepsze-produkty/page";
import ArticleJordan from "@/pages/article/kakobuy-spreadsheet-jordan-ranking/page";
import ArticleDeals from "@/pages/article/najlepsze-okazje-kakobuy-spreadsheet-2026/page";
import ArticleBeginner from "@/pages/article/kakobuy-spreadsheet-dla-poczatkujacych/page";
import ArticleReviews from "@/pages/article/recenzja-spolecznosci-kakobuy-spreadsheet-2026/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/jak-korzystac-z-kakobuy-spreadsheet",
    element: <ArticleMainGuide />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-top-50-produktow",
    element: <ArticleTop50 />,
  },
  {
    path: "/artykul/kakobuy-qc-kompletny-poradnik",
    element: <ArticleQC />,
  },
  {
    path: "/artykul/wysylka-do-polski-z-chin-kakobuy",
    element: <ArticleShipping />,
  },
  {
    path: "/artykul/kakobuy-vs-pandabuy-porownanie-2026",
    element: <ArticleVs />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-nike-najlepsze-produkty",
    element: <ArticleNike />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-jordan-ranking",
    element: <ArticleJordan />,
  },
  {
    path: "/artykul/najlepsze-okazje-kakobuy-spreadsheet-2026",
    element: <ArticleDeals />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-dla-poczatkujacych",
    element: <ArticleBeginner />,
  },
  {
    path: "/artykul/recenzja-spolecznosci-kakobuy-spreadsheet-2026",
    element: <ArticleReviews />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;